<div class="go-container">

  <go-card class="go-column go-column--100" id="usage">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Usage</h2>
      <go-copy cardId="usage" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          The <code class="code-block--inline">&lt;go-header&gt;</code> component should only be used once, at the root level component.
          It should be placed inside a <code class="code-block--inline">&lt;go-layout&gt;</code> and be given the attribute of 
          <code class="code-block--inline">&lt;go-layout-header&gt;</code>.
          This component will render a header across the top of the application that contains an icon button to collapse the side nav, bindings
          for a logo, a slot for the search component in the middle, and a slot for actions on the right.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h3 class="go-heading-3">Bindings</h3>
        <code [highlight]="componentBindings"></code>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">altText</h4>
        <p class="go-body-copy go-body-copy--no-margin">
          This binding will output the alt text for the logo image. This is optional, but recommended.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">logo</h4>
        <p class="go-body-copy go-body-copy--no-margin">
          This binding takes the path to the logo.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">logoLink</h4>
        <p class="go-body-copy go-body-copy--no-margin">
          This binding takes a URL to direct the user to if they click the logo area.
          If using a routerLink, the route relative to the root of the application should be passed or it will default to root.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">logoLinkUseRouterLink</h4>
        <p class="go-body-copy go-body-copy--no-margin">
          This binding tells the component to render the link as a routerLink or traditional href. By default it will use a routerLink.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <h3 class="go-heading-3">Content Projection</h3>
        <p class="go-body-copy go-body-copy--no-margin">
          In addtiion to the bindings, there are two areas used for content projection: <code class="code-block--inline">go-header-middle</code>
          and <code class="code-block--inline">go-header-right</code>. These should be applied to the <code class="code-block--inline">&lt;go-search&gt;</code>
          component and an <code class="code-block--inline">&lt;ng-container&gt;</code> element respectively. Check the example below for details.
        </p>
      </div>

    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="setup">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Simple Setup</h2>
      <go-copy cardId="setup" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>
      <div class="go-column go-column--100 go-column--no-padding">
        <p class="go-body-copy">
          For the sake of this example, we'll be referencing the layout of this application because it's a living example of the
          entire layout component and family. It is also being shown inside of the layout component because it's required to be inside it.
        </p>
        
        <h4 class="go-heading-4">app.module</h4>
        <code [highlight]="basicExample_module"></code>
        
        <h4 class="go-heading-4">app.component.html</h4>
        <code [highlight]="basicExample_html"></code>
      </div>
    </div>
  </go-card>

</div>
